import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EmployeeResourcesPage from "@/pages/employee/EmployeeResourcesPage";

export const Route = createFileRoute("/employee/resources")({
  head: () => pageHead("Employee · Resources", "AKIVA employee · resources portal.", "/employee/resources", true),
  component: EmployeeResourcesPage,
});
